import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import axios from "axios";
import url from "../../url.json";
import headers from "../../config/headers";
import { Skeleton, Tooltip } from "antd";
import "../../pages/layout/cabinet.scss";

const GROUPS = [
  {
    title: "ln_cab_group_apps",
    items: [
      { to: "/account/applicationsadd", icon: "bx-plus-circle", label: "Add application" },
      { to: "/account/applications", icon: "bx-file", label: "Application list" },
      { to: "/account/contract", icon: "bx-pen", label: "Contracts list" },
      { to: "/account/mycertificates", icon: "bx-badge-check", label: "My Sertificats" },
    ],
  },
  {
    title: "ln_cab_group_dup",
    items: [
      { to: "/account/duplicate-applicationsadd", icon: "bx-copy-alt", label: "Duplicate Add application" },
      { to: "/account/duplicate-applications", icon: "bx-list-ul", label: "Duplicate Application list" },
      { to: "/account/my-duplicate-certificates", icon: "bx-certification", label: "My Duplicate Sertificats" },
    ],
  },
  {
    title: "ln_cab_group_account",
    items: [
      { to: "/account/notic", icon: "bx-bell", label: "Notifications", badge: true },
      { to: "/account/profile", icon: "bx-user", label: "Profile" },
      { to: "/account/settings", icon: "bx-cog", label: "Settings" },
    ],
  },
];

function Sidebar({ t }) {
  const navigate = useNavigate();
  const profile = useSelector((state) => state.profile?.data?.[0]?.data);
  const notice = useSelector((state) => state.notic);
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    axios
      .get(url.url + `/notice?search=read&&count=count`, { headers: headers() })
      .then((res) => setUnread(Number(res.data.data) || 0))
      .catch(() => {});
  }, [notice]);

  const legal = profile?.legal_entity;
  const status = !legal
    ? null
    : legal.blocked_at
    ? { cls: "is-blocked", label: "ln_status_blocked", hint: "blog_info" }
    : legal.verified_at
    ? { cls: "is-verified", label: "ln_status_verified", hint: "success_info" }
    : { cls: "is-pending", label: "ln_status_pending", hint: "warning_info" };

  return (
    <div className="ln-side">
      <div className="ln-side__profile" onClick={() => navigate("/account/profile")}>
        {profile ? (
          <>
            {profile.avatar ? (
              <img className="ln-side__avatar" src={profile.avatar} alt="" />
            ) : (
              <span className="ln-side__avatar">{profile.username?.charAt(0)}</span>
            )}
            <div className="ln-side__who">
              <strong>{legal?.name || profile.username}</strong>
              <small>{profile.username}</small>
              {status ? (
                <Tooltip placement="bottom" title={t(status.hint)}>
                  <span className={`ln-side__status ${status.cls}`}>
                    <i className={`bx ${status.cls === "is-verified" ? "bxs-check-circle" : status.cls === "is-blocked" ? "bxs-x-circle" : "bxs-time"}`} />
                    {t(status.label)}
                  </span>
                </Tooltip>
              ) : (
                ""
              )}
            </div>
          </>
        ) : (
          <Skeleton avatar active paragraph={{ rows: 1 }} />
        )}
      </div>

      <nav className="ln-side__nav">
        {GROUPS.map((group) => (
          <div key={group.title} className="ln-side__group">
            <span className="ln-side__group-title">{t(group.title)}</span>
            {group.items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => `ln-side__link${isActive ? " active" : ""}`}
              >
                <i className={`bx ${item.icon}`} />
                <span>{t(item.label)}</span>
                {item.badge && unread > 0 ? <em className="ln-side__badge">{unread}</em> : ""}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
    </div>
  );
}
export default withTranslation()(Sidebar);
